import React from 'react';
import Select from 'react-select';

import {
  KindOfScience,
  KindOfScienceText,
} from '../../../common/spdCore/validation/schemas';

interface KindOfScienceSelectorProps {
  value?: string | null;
  onChange: (value: string) => void;
}

const allOptions = Object.keys(KindOfScience).map(name => ({
  value: name,
  label: KindOfScienceText[name as keyof typeof KindOfScience],
}));

export const KindOfScienceSelector: React.FC<KindOfScienceSelectorProps> = ({
  value,
  onChange,
}) => {
  const selected = allOptions.filter(item =>
    value?.split(',').includes(item.value),
  );

  return (
    <Select
      options={allOptions}
      value={selected}
      isMulti
      className="test-multi-select"
      classNamePrefix="driving-select"
      onChange={options => onChange(options.map(o => o.value).join(','))}
    />
  );
};
